import { render, staticRenderFns } from "./UpdateNavigationDialog.vue?vue&type=template&id=20a2c8c4&scoped=true&lang=pug&"
import script from "./UpdateNavigationDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateNavigationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a2c8c4",
  null
  
)

export default component.exports